/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Канал
 */
export enum ChannelEnum {
  MOBILE = "MOBILE",
  WEB = "WEB",
  ALL = "ALL",
}

/**
 * Данные формы обратной связи
 */
export interface FeedbackData {
  /**
   * Название опроса
   * @example Оценка мнения
   */
  name: string;

  /**
   * Ключ
   * @example ???
   */
  key: string;

  /** Тип */
  type: FeedbackTypeEnum;

  /** Канал */
  channel: ChannelEnum;

  /**
   * Название продукта
   * @example ?
   */
  productName: string;

  /**
   * Дата начала опроса
   * @format date-time
   */
  beginDate?: string;

  /**
   * Дата оконочания опроса
   * @format date-time
   */
  endDate?: string;

  /**
   * Активность
   * @example true
   */
  isActive: boolean;

  /**
   * json схема
   * @example {}
   */
  schema: string;

  /**
   * Включено на всех клиентах
   * @example true
   */
  allClients?: boolean;
}

/**
 * Тип
 */
export enum FeedbackTypeEnum {
  NPS = "NPS",
  CES = "CES",
  CSAT = "CSAT",
  CSI = "CSI",
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Данные клиентской формы обратной связи
 */
export interface FeedbackDataFromClient {
  /**
   * Ключ
   * @example ???
   */
  key?: string;

  /** Канал */
  channel?: ChannelEnum;

  /**
   * json схема
   * @example {}
   */
  response?: string;

  /**
   * Закрыл ли пользователь форму
   * @example false
   */
  isClosed?: boolean;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * csv файл в base64 c ИНН клиентов
 */
export interface ClientsFile {
  /** ключ опроса к которому надо привязать клиентов */
  feedbackKey: string;

  /** csv файл в base64 c ИНН клиентов */
  clientsFile: string;
}

/**
 * Отчет по загрузке клиентов
 */
export interface UploadClientsResp {
  /**
   * Количество загружаемых клиентов
   * @format int32
   * @example 10
   */
  count: number;

  /**
   * Успешно обработанны
   * @format int32
   * @example 9
   */
  success: number;

  /**
   * Ошибок обработки
   * @format int32
   * @example 1
   */
  error: number;

  /**
   * Лог ошибок base64
   * @example 0JrQu9C40LXQvdGCINGBINCY0J3QnSA1NzUxMDA2MDUxINC90LUg0L3QsNC50LTQtdC9
   */
  errorFile: string;
}

/**
 * Список созданных форм
 */
export interface FeedbackDataList {
  /** Список опросов */
  feedbackForms?: FeedbackData[];

  /**
   * Общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Подробные данные формы обратной связи
 */
export interface AdditionalScoreInfoNPS {
  /** Общая схема для оценок пользователей */
  detractors?: ScoreData;

  /** Общая схема для оценок пользователей */
  passives?: ScoreData;

  /** Общая схема для оценок пользователей */
  promoters?: ScoreData;
}

/**
 * Подробные данные формы обратной связи
 */
export interface DetailedFeedbackData {
  /**
   * Название опроса
   * @example Оценка мнения
   */
  name: string;

  /**
   * Ключ
   * @example ???
   */
  key: string;

  /** Тип */
  type: FeedbackTypeEnum;

  /** Канал */
  channel: ChannelEnum;

  /**
   * Название продукта
   * @example ?
   */
  productName: string;

  /**
   * Дата начала опроса
   * @format date-time
   */
  beginDate?: string;

  /**
   * Дата оконочания опроса
   * @format date-time
   */
  endDate?: string;

  /**
   * Активность
   * @example true
   */
  isActive: boolean;

  /**
   * json схема
   * @example {}
   */
  schema: string;

  /**
   * Включено на всех клиентах
   * @example true
   */
  allClients?: boolean;

  /**
   * Первичный ключ
   * @format uuid
   * @example dd19babd-1334-4bb4-a4da-3ad35fe00a1c
   */
  id: string;

  /**
   * Общая оценка ОС
   * @example ???
   */
  overallScore?: string;

  /** Подробные данные формы обратной связи */
  additionalScoreInfo_NPS?: AdditionalScoreInfoNPS;

  /** Дополнительная информация об оценках пользователей если форма CES CSAT */
  additionalScoreInfo_CES_CSAT?: Record<string, ScoreData>;

  /** Дополнительная информация об оценках пользователей если форма CSI */
  additionalScoreInfoCSI?: Record<string, ScoreCsiData>;
}

/**
 * Схема оценки CSI
 */
export interface ScoreCsiData {
  /**
   * Средняя значимость
   * @format double
   * @example 4.6
   */
  averageImportance?: number;

  /**
   * Средняя оценка
   * @format double
   * @example 7.2
   */
  averageSatisfaction?: number;
}

/**
 * Общая схема для оценок пользователей
 */
export interface ScoreData {
  /**
   * Количество
   * @format int64
   * @example 600
   */
  number?: number;

  /**
   * Процент
   * @format double
   * @example 30
   */
  percentage?: number;
}

/**
 * Форма ответа сортудника для АРМ
 */
export interface FeedbackClientData {
  /**
   * id пользователя
   * @example 123e4567-e89b-12d3-a456-426655440000
   */
  delegateId?: string;

  /**
   * Имя пользователя
   * @example Bill
   */
  delegateFullName?: string;

  /**
   * id компании
   * @example 123e4567-e89b-12d3-a456-426655440000
   */
  orgId?: string;

  /**
   * Название компании
   * @example Bill unskill & co
   */
  orgFullName?: string;

  /**
   * Дата
   * @format date-time
   */
  collectDate?: string;

  /**
   * Ответ по опросу
   * @example {}
   */
  response?: string;
}

/**
 * Список ответов для арм
 */
export interface FeedbackClientDataList {
  /** Список ответов для арм */
  feedbackClientDataList?: FeedbackClientData[];

  /**
   * Общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Данные клиентской формы обратной связи
 */
export interface FeedbackDataForClient {
  /** Тип */
  type?: FeedbackTypeEnum;

  /**
   * json схема
   * @example {}
   */
  schema?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-survey
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-survey.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Настройки
     * @name GetFeedbackData
     * @summary Получение опросов
     * @request GET:/api/survey/v1/internal/settings/forms
     */
    getFeedbackData: (
      query?: {
        page?: number;
        limit?: number;
        type?: "NPS" | "CES" | "CSAT" | "CSI";
        channel?: "MOBILE" | "WEB" | "ALL";
        productName?: string;
        beginDate?: string;
        endDate?: string;
        name?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<FeedbackDataList, GenericError>({
        path: `/api/survey/v1/internal/settings/forms`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name UpdateFeedbackData
     * @summary Редактирование опроса
     * @request PUT:/api/survey/v1/internal/settings/forms
     */
    updateFeedbackData: (data: FeedbackData, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/survey/v1/internal/settings/forms`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name SaveNewFeedbackData
     * @summary Создание опроса
     * @request POST:/api/survey/v1/internal/settings/forms
     */
    saveNewFeedbackData: (data: FeedbackData, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/survey/v1/internal/settings/forms`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name GetFeedbackformForClient
     * @summary Форма опроса для показа клиенту
     * @request GET:/api/survey/v1/external/forms
     */
    getFeedbackformForClient: (
      query: { key: string; channel: "MOBILE" | "WEB" | "ALL" },
      params: RequestParams = {}
    ) =>
      this.request<FeedbackDataForClient, GenericError>({
        path: `/api/survey/v1/external/forms`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name PutFeedbackDataFromClient
     * @summary Ответ по форме от клиента
     * @request PUT:/api/survey/v1/external/forms
     */
    putFeedbackDataFromClient: (
      data: FeedbackDataFromClient,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/survey/v1/external/forms`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name UploadClientsForBanner
     * @summary Загрузка клиентов файлом
     * @request POST:/api/survey/v1/internal/settings/forms/clients
     */
    uploadClientsForBanner: (data: ClientsFile, params: RequestParams = {}) =>
      this.request<UploadClientsResp, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/clients`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name GetDetailedFeedbackData
     * @summary Статистика по опросу
     * @request GET:/api/survey/v1/internal/settings/forms/{feedbackKey}
     */
    getDetailedFeedbackData: (
      feedbackKey: string,
      params: RequestParams = {}
    ) =>
      this.request<DetailedFeedbackData, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/${feedbackKey}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name DeleteFeedbackForm
     * @summary Удаление опроса
     * @request DELETE:/api/survey/v1/internal/settings/forms/{feedbackKey}
     */
    deleteFeedbackForm: (feedbackKey: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/${feedbackKey}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name GetFeedbackClientData
     * @summary Получение ответов от клиента
     * @request GET:/api/survey/v1/internal/settings/forms/response/{feedbackKey}
     */
    getFeedbackClientData: (
      feedbackKey: string,
      query?: {
        page?: number;
        limit?: number;
        searchString?: string;
        beginDate?: string;
        endDate?: string;
        score?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<FeedbackClientDataList, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/response/${feedbackKey}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name GetClientsForSurvey
     * @summary Получение уже загруженных клиентов
     * @request GET:/api/survey/v1/internal/settings/forms/clients/{feedbackKey}
     */
    getClientsForSurvey: (feedbackKey: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/clients/${feedbackKey}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name DeleteClientsForSurvey
     * @summary Удаление клиентов
     * @request DELETE:/api/survey/v1/internal/settings/forms/clients/{feedbackKey}
     */
    deleteClientsForSurvey: (feedbackKey: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/survey/v1/internal/settings/forms/clients/${feedbackKey}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Инициализация справочников
     * @name InitDicts
     * @summary Инициализация справочников
     * @request GET:/api/survey/v1/internal/init-replication
     */
    initDicts: (params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/survey/v1/internal/init-replication`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
